import type { ReactNode } from 'react';

/**
 * Small gold "master" capsule so the master warehouse is identifiable in EVERY warehouse picker across the app.
 * Matches the gold/harvest accent used for the master warehouse elsewhere (e.g. the Master Stock banner tag).
 */
export function MasterTag({ className = '' }: { className?: string }) {
  return (
    <span className={`ml-1.5 shrink-0 whitespace-nowrap rounded-full border border-harvest-500/45 bg-harvest-400/25 px-1.5 py-px text-[10px] font-semibold uppercase tracking-wide text-harvest-700 dark:border-harvest-400/40 dark:bg-harvest-400/20 dark:text-harvest-300 ${className}`}>
      master
    </span>
  );
}

type WhLike = { code?: string | null; name?: string | null; isMaster?: boolean | number | null };

/** "CODE · Name" plain text — use as the searchable `label` string on antd Selects (then render the capsule
 *  separately via `optionRender`). */
export const warehouseText = (w: WhLike): string => [w.code, w.name].filter(Boolean).join(' · ') || '—';

/**
 * Label node = "CODE · Name" + a master capsule when the warehouse is the master. Use directly as the option
 * `label` for a ui/Select or a NON-searchable antd Select. For a SEARCHABLE antd Select (optionFilterProp="label"),
 * keep `label: warehouseText(w)` (a string, so search works) and render the capsule via `optionRender`.
 */
export function warehouseLabel(w: WhLike): ReactNode {
  return (
    <span className="inline-flex items-center">
      {warehouseText(w)}
      {w.isMaster ? <MasterTag /> : null}
    </span>
  );
}
